import React, { useRef, useEffect } from 'react'
import * as styles from "./Header.module.scss";
import logoText1 from "../../../images/on-going-projects/srinivasa/srinivasa-text-1.png";
import logoText2 from "../../../images/on-going-projects/srinivasa/srinivasa-text-2.png";

function Header({ currentSectionIndex, setCurrentSectionIndex }) {
  const activeSectionBottomRef = useRef(null);
  const menuItemsRef = useRef([]);

  const scrollToSection = (section) => {
    window.scrollTo({
      top: document.querySelector(`#section-${section}`).offsetTop - 165,
      behavior: "smooth",
    });
  }

  useEffect(() => {
    bottomBarFn()
  }, [currentSectionIndex])

  const bottomBarFn = () => {
    if(currentSectionIndex > 1) {
    activeSectionBottomRef.current.style.opacity = 1;
    activeSectionBottomRef.current.style.left = `${menuItemsRef.current[currentSectionIndex - 2].offsetLeft}px`;
    activeSectionBottomRef.current.style.width = `${menuItemsRef.current[currentSectionIndex - 2].offsetWidth}px`;
    }
    else {
      activeSectionBottomRef.current.style.opacity = 0;
      activeSectionBottomRef.current.style.left = `${menuItemsRef.current[0].offsetLeft}px`;
      activeSectionBottomRef.current.style.width = `${menuItemsRef.current[0].offsetWidth}px`;
    }
  }

  return (
    <>
    <div className={styles.header + ' ' + (currentSectionIndex === 1 ? styles.header1In : '')} id="srinivasa-header">
        <span className={styles.headerLogo} onClick={() => {
          scrollToSection(1);
          setCurrentSectionIndex(1);
        }}>
        <img src={logoText1} alt="Srinivasa Logo" className={styles.logoText1} /></span>

        <div className={styles.headerLinks}>
          <div className={styles.activeSectionBottom} ref={activeSectionBottomRef} />
            <span onClick={() => {
              scrollToSection(2);
              setCurrentSectionIndex(2);  
            }} ref={el => menuItemsRef.current[0] = el} className={`${styles.headerLink} ${currentSectionIndex === 2 ? styles.active : ""}`}>Project Synopsis</span>
            <span onClick={() => {
              scrollToSection(3);
              setCurrentSectionIndex(3);
            }} ref={el => menuItemsRef.current[1] = el} className={`${styles.headerLink} ${currentSectionIndex === 3 ? styles.active : ""}`}>Project Specifications</span>
            <span onClick={() => {
              setCurrentSectionIndex(4);
              scrollToSection(4);
            }} ref={el => menuItemsRef.current[2] = el} className={`${styles.headerLink} ${currentSectionIndex === 4 ? styles.active : ""}`}>Floor Plan</span>
            <span onClick={() => {
              scrollToSection(5);
              setCurrentSectionIndex(5);
            }} ref={el => menuItemsRef.current[3] = el} className={`${styles.headerLink} ${currentSectionIndex === 5 ? styles.active : ""}`}>Gallery</span>
            <span onClick={() => {
              setCurrentSectionIndex(6);
              scrollToSection(6);
            }} ref={el => menuItemsRef.current[4] = el} className={`${styles.headerLink} ${currentSectionIndex === 6 ? styles.active : ""}`}>Project Status</span>
            <span onClick={() => {
              setCurrentSectionIndex(7);
              scrollToSection(7);
            }} ref={el => menuItemsRef.current[5] = el} className={`${styles.headerLink} ${currentSectionIndex === 7 ? styles.active : ""}`}>Location</span>
        </div>
    </div>

    <div className={styles.header + ' ' + (currentSectionIndex === 1 ? '' : styles.header2In)} id="srinivasa-header">
        <span className={styles.headerLogo} onClick={() => {
          scrollToSection(1);
          setCurrentSectionIndex(1);
        }}><img src={logoText2} alt="Srinivasa Logo" className={styles.logoText2} /></span>

        <div className={styles.headerLinks}>
          <div className={styles.activeSectionBottom} ref={activeSectionBottomRef} />
            <span onClick={() => {
              scrollToSection(2);
              setCurrentSectionIndex(2);  
            }} ref={el => menuItemsRef.current[0] = el} className={`${styles.headerLink} ${currentSectionIndex === 2 ? styles.active : ""}`}>Project Synopsis</span>
            <span onClick={() => {
              scrollToSection(3);
              setCurrentSectionIndex(3);
            }} ref={el => menuItemsRef.current[1] = el} className={`${styles.headerLink} ${currentSectionIndex === 3 ? styles.active : ""}`}>Project Specifications</span>
            <span onClick={() => {
              setCurrentSectionIndex(4);
              scrollToSection(4);
            }} ref={el => menuItemsRef.current[2] = el} className={`${styles.headerLink} ${currentSectionIndex === 4 ? styles.active : ""}`}>Floor Plan</span>
            <span onClick={() => {
              scrollToSection(5);
              setCurrentSectionIndex(5);
            }} ref={el => menuItemsRef.current[3] = el} className={`${styles.headerLink} ${currentSectionIndex === 5 ? styles.active : ""}`}>Gallery</span>
            <span onClick={() => {
              setCurrentSectionIndex(6);
              scrollToSection(6);
            }} ref={el => menuItemsRef.current[4] = el} className={`${styles.headerLink} ${currentSectionIndex === 6 ? styles.active : ""}`}>Project Status</span>
            <span onClick={() => {
              setCurrentSectionIndex(7);
              scrollToSection(7);
            }} ref={el => menuItemsRef.current[5] = el} className={`${styles.headerLink} ${currentSectionIndex === 7 ? styles.active : ""}`}>Location</span>
        </div>
    </div>
    </>
  )
}

export default Header